import { router } from '@inertiajs/react'
import type CrmPeopleNote from '@/types/serializers/CrmPeopleNote'
import { TiptapEditor } from './TiptapEditor'
import { NoteCard } from './NoteCard'

interface NotesTabProps {
  notes: CrmPeopleNote[]
  noteableType: 'individual_donor' | 'organization_donor' | 'contact'
  noteableId: number
  organizationDonorId?: number
  currentUserId: number
  onReloadDetail?: () => void
}

function buildBasePath(
  noteableType: NotesTabProps['noteableType'],
  noteableId: number,
  organizationDonorId?: number
): string {
  switch (noteableType) {
    case 'individual_donor':
      return `/people/individual_donors/${noteableId}/notes`
    case 'organization_donor':
      return `/people/organization_donors/${noteableId}/notes`
    case 'contact':
      return `/people/organization_donors/${organizationDonorId}/contacts/${noteableId}/notes`
  }
}

export function NotesTab({
  notes,
  noteableType,
  noteableId,
  organizationDonorId,
  currentUserId,
  onReloadDetail,
}: NotesTabProps) {
  const basePath = buildBasePath(noteableType, noteableId, organizationDonorId)

  function handleAddNote(html: string) {
    router.post(
      basePath,
      { note: { content: html } },
      { preserveScroll: true, only: ['notes'] }
    )
  }

  function handleEditNote(noteId: number, html: string) {
    router.patch(
      `${basePath}/${noteId}`,
      { note: { content: html } },
      { preserveScroll: true, only: ['notes'] }
    )
  }

  function handleDeleteNote(noteId: number) {
    router.patch(
      `${basePath}/${noteId}/archive`,
      {},
      { preserveScroll: true, only: ['notes'] }
    )
  }

  return (
    <div className="space-y-4">
      <TiptapEditor onSave={handleAddNote} />

      <div>
        {notes.length === 0 ? (
          <p className="text-sm text-muted-foreground text-center py-6">
            Aucune note pour le moment.
          </p>
        ) : (
          <div>
            {notes.map((note) => (
              <NoteCard
                key={note.id}
                note={note}
                currentUserId={currentUserId}
                onEdit={handleEditNote}
                onDelete={handleDeleteNote}
              />
            ))}
          </div>
        )}
      </div>
    </div>
  )
}
